/**
 * Scaffold Field Mapping
 * Maps field names to their display labels (matching groundworks_rates_mapping.json)
 */

export const SCAFFOLD_FIELD_LABELS: { [fieldName: string]: string } = {
  // Base measurements
  scaffoldPlatform: "Scaffold Platform",
  loadingBay4x2m: "Loading bay 4x2m",
  stairAccess3x3m: "Stair Access 3x3m",

  // Section 1 - Scaffold Platform (matching JSON frontend_label)
  scaffoldLevelCompact: "Level & Compact",
  scaffoldGeotextileLayer: "Geotextile Layer",
  scaffoldCrush6F2: "xxxmm crush 6F2",
  scaffoldType1: "xxmm Type1",

  // Section 2 - Loading Bays (matching JSON frontend_label)
  loadingLevelCompact: "Level & Compact",
  loadingGeotextileLayer: "Geotextile Layer",
  loadingCrush6F2: "xxxmm crush 6F2",
  loadingType1: "xxmm Type1",

  // Stair Access (matching JSON frontend_label)
  stairLevelCompact: "Level & Compact",
  stairGeotextileLayer: "Geotextile Layer",
  stairCrush6F2: "xxxmm crush 6F2",
  stairType1: "xxmm Type1",
};

/**
 * Units for Scaffold fields
 */
export const SCAFFOLD_FIELD_UNITS: { [fieldName: string]: string } = {
  // Base measurements
  scaffoldPlatform: "m²",
  loadingBay4x2m: "m²",
  stairAccess3x3m: "m²",

  // Scaffold Platform - m²
  scaffoldLevelCompact: "m²",
  scaffoldGeotextileLayer: "m²",
  scaffoldCrush6F2: "m²",
  scaffoldType1: "m²",

  // Loading Bays - m²
  loadingLevelCompact: "m²",
  loadingGeotextileLayer: "m²",
  loadingCrush6F2: "m²",
  loadingType1: "m²",

  // Stair Access - m²
  stairLevelCompact: "m²",
  stairGeotextileLayer: "m²",
  stairCrush6F2: "m²",
  stairType1: "m²",
};

/**
 * Get the display label for a Scaffold field
 */
export function getScaffoldFieldLabel(fieldName: string): string | null {
  return SCAFFOLD_FIELD_LABELS[fieldName] || null;
}

/**
 * Get the unit for a Scaffold field
 */
export function getScaffoldFieldUnit(fieldName: string): string | null {
  return SCAFFOLD_FIELD_UNITS[fieldName] || null;
}
